var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"dense":"","nav":""}},[_c('v-list-item-group',{attrs:{"active-class":"primary white--text"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }